var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "btn btn-default audio-player",
      attrs: { type: "button" },
      on: { click: _vm.toggle },
    },
    [
      _c("span", {
        class: {
          fa: true,
          "fa-play": !_vm.isPlaying,
          "fa-pause": _vm.isPlaying,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }